import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { getQaSelector } from '../../../utils/common'
import Button from '../../Button'
import { ClampingText } from '../../ClampingText'
import Text from '../../Text'
import { NotificationIcon } from '../NotificationIcon'
import { NotificationLink } from '../NotificationLink'
import { NotificationTextButton } from '../NotificationTextButton'

import { QA_NAME_FORM_NOTIFICATION } from './NotificationInline.constants'
import { getActionKey } from './NotificationInline.utils'

import * as styles from './NotificationInline.module.css'

function NotificationInline({
  actions,
  children,
  className,
  linkProps,
  qaName = QA_NAME_FORM_NOTIFICATION,
  text,
  type,
}) {
  const { t } = useTranslation()

  const notificationClassName = classNames(styles.notification, className)

  const colorLayerClassName = classNames(styles.colorLayer, styles[type])

  const actionClassName = classNames(styles.action, styles[type])

  const linkClassName = classNames(styles.link, actionClassName)

  const qaProps = getQaSelector({ value: qaName })

  return (
    <div {...qaProps} className={notificationClassName}>
      <div className={colorLayerClassName}>
        <NotificationIcon className={styles.icon} type={type} />
        <div className={styles.content}>
          <ClampingText
            Button={Button.Text}
            buttonClassName={actionClassName}
            className={styles.text}
            fullText={text}
            isGreyButton={false}
          />
          {children}
          {actions?.length > 0 ? (
            <div className={styles.actionsBox}>
              {actions.map((action, index) => (
                <Fragment key={getActionKey(action, index)}>
                  {index > 0 ? <Text>{t('Common.OrKey')}</Text> : null}
                  <NotificationTextButton
                    beforeIconProps={action.beforeIconProps}
                    className={actionClassName}
                    isLoading={action.isLoading}
                    text={action.text}
                    onClick={action.callback}
                  />
                </Fragment>
              ))}
            </div>
          ) : null}
          {linkProps ? (
            <NotificationLink {...linkProps} className={linkClassName} />
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default NotificationInline
